// removed by extract-text-webpack-plugin
module.exports = {"container":"upload-source-cell-formatter__container___3_1Qn","tooltip":"upload-source-cell-formatter__tooltip___KO_CX"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/grid/cell-formatters/upload-source-cell-formatter.scss
// module id = 1339
// module chunks = 0